import { inject, Injectable } from '@angular/core';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';
import {
  ContactUsDocument,
  ContactUsMutationVariables,
  ContactUsOutput,
} from '@shared/graphql/support.generated';

@Injectable()
export class SupportService {
  private readonly graphqlService = inject(GraphqlService);

  submitSupport(variables: ContactUsMutationVariables) {
    return this.graphqlService.makeMutation<ContactUsOutput>(
      GraphqlClients.supportClient,
      ContactUsDocument,
      variables,
    );
  }
}
